<template>
  <div>
    <p>PRVY</p>
    <quill-editor v-model="content" :options="editorOption1">
      <div id="toolbara" slot="toolbar">
        <span class="ql-formats">
          <button class="ql-header" value="1"></button>
          <button class="ql-header" value="2"></button>
        </span>        
        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-code-block"></button>
          <button class="ql-blockquote"></button>
          <select class="ql-color"></select>
          <select class="ql-background"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-script" value="sub"></button>
          <button class="ql-script" value="super"></button>
        </span>

        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
          <button class="ql-indent" value="-1"></button>
          <button class="ql-indent" value="+1"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-align"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-link"></button>
          <button class="ql-image"></button>
          <button class="ql-formula"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean"></button>
        </span>

        <span class="ql-formats">
          <button  @click="customButtonClick($event)"><v-icon>settings_ethernet</v-icon></button>
        </span>


      </div>  
    </quill-editor>
    <hr>
      <div>
    <p>DRUHY</p>
    <quill-editor v-model="content2" :options="editorOption2">
    </quill-editor>
      </div>

    <textarea name="aaa" id="" cols="30" rows="10" v-model="contenthlp"></textarea>
    <v-btn @click="update()">update</v-btn>

<hr>
<p>{{content}}</p>
    <hr>

  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import hljs from 'highlight.js'
import { quillEditor } from 'vue-quill-editor'
// import 'highlight.js/styles/googlecode.css'

export default {
  data() {
    return {
      content: 'import and not for a = 10',
      content2: 'sss aaaa dddd',
      contenthlp : null,
      editorOption1: {
          modules: {
            toolbar: '#toolbara',
    /*        syntax: {
              highlight: text => hljs.highlightAuto(text).value
            },
      */      imageDrop: true,
            imageResize: true
          },
            theme: 'snow'
      },
    editorOption2: {
          modules: {
            'toolbar': [
              [{ 'header': '1' }, { 'header': '2' }],
              [ 'bold', 'italic', 'underline', 'strike' ],
              ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
              [{ 'script': 'super' }, { 'script': 'sub' }],
              [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'align': [] }],
              [ 'link', 'image', 'formula' ],
              [ 'clean' ]
            ],
      /*      syntax: {
              highlight: text => hljs.highlightAuto(text).value
            },
        */    imageDrop: true,
            imageResize: true
          },
          theme: 'snow'
      }
    }
  },
  components: {
    quillEditor
  },
  methods : {
      customButtonClick() {
        const quill = this.$refs.myQuill.quill
        var selection = quill.getSelection();
        // var selectedContent = quill.getContents(selection.index, selection.length);
        quill.insertText(quill.getSelection().index + selection.length, '§§')
        quill.insertText(quill.getSelection().index, '§§')
      },
      update() {
        this.content = this.contenthlp
      }
  }
}
</script>

<style lang="scss" scoped>
</style>